import { createSlice } from '@reduxjs/toolkit';
import { STORAGE_KEYS } from '../../constants';

const initialState = {
  hasAcceptedCookiePolicy: window.localStorage.getItem(STORAGE_KEYS.ACCEPTED_COOKIES)
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    acceptCookiePolicyComplete: (state) => {
      window.localStorage.setItem(STORAGE_KEYS.ACCEPTED_COOKIES, true);

      return {
        ...state,
        hasAcceptedCookiePolicy: true
      };
    },

    reset: () => {
      return {
        ...initialState
      };
    }
  }
});

export const globalActions = globalSlice.actions;
export default globalSlice.reducer;
